import * as _ from 'lodash';
import {ApiModel} from "./api.model";

export const AdditionalFee = ApiModel.extend({
    props: {
        id: 'number',
        fee_type: 'string',
        fee_desc: 'string',
    },
    extraProperties: 'ignore',
});
